import React, { } from 'react'
import { Box } from '@material-ui/core';

import { useTheme } from '@material-ui/core/styles';
import { CustomTinyButton } from '../../common/CustomComponents';
import { useCalculator, DISPATCH_RESET_SALARY } from '../../../state/calculatorState';
import { useLayout, RESET } from '../../../state/layoutState';
import { compileOptions } from '../../../utils/utils'

export const ResetCalculator = (props) => {
    const theme = useTheme();
    const [calculator, dispatchCalculator] = useCalculator();
    const [, dispatchLayout] = useLayout();

    const options = compileOptions(calculator);
    const optionsLabels = options.map(o => o[0]);
    const defaultState = optionsLabels && optionsLabels.length === 0;

    const handleReset = (e) => {
        e.stopPropagation();
        return (
            dispatchCalculator({
                type: DISPATCH_RESET_SALARY,
                data: 0,
            }),
            dispatchLayout({
                type: RESET,
                data: 0,
            })
        )
    }


    if (props.hidden) {
        return null;
    }


    return (
            <Box display="flex" alignItems="center" flexDirection="row" style={{height:'100%'}}>
                <CustomTinyButton tabIndex="-1" variant="contained" 
                    style={defaultState ? {width:'100%'} : { width:'100%', backgroundColor: theme.palette.secondary.light }}
                    // style={ { width:'100%', backgroundColor: defaultState ? theme.palette.primary.light : theme.palette.secondary.light } } 
                    disabled={defaultState} 
                    onClick={handleReset}
                >Reset calculator</CustomTinyButton>
            </Box>
    )
}

export default ResetCalculator;